import type { BrandSignal } from "@/data/mockBrandSignalsData";

export function countNonRefutedSignals(signals: BrandSignal[]): number {
  return signals.filter((s) => s.status !== "refuted").length;
}
